module.exports = __webpack_public_path__ + "img/case-阿斯.5d5c2e6c.png";